import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Custom hook that detects route changes and calls a callback when the route changes
 * @param callback Function to call when route changes
 * @param dependencies Optional dependencies array for the callback
 */
const useRouteChange = (callback: () => void, dependencies: unknown[] = []) => {
  const location = useLocation()
  const previousPathnameRef = useRef(location.pathname)

  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname) {
      callback()
      previousPathnameRef.current = location.pathname
    }
    // dependencies is a caller-provided array; spread so each value is compared
    // individually instead of by the array's reference (which changes every render)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, callback, ...dependencies])
}

export default useRouteChange
